// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/request-form-schema',
  type: 'object',
  required: ['id', 'creatorId'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    submissionDate: {
      type: 'string',
      format: 'date-time',
    },
    requestId: {
      type: 'string',
      nullable: true,
    },
    formType: {
      type: 'string',
      nullable: true,
    },
    formSubType: {
      type: 'string',
      nullable: true,
    },
    formSummaryType: {
      type: 'string',
      nullable: true,
    },
    customerEmail: {
      type: 'string',
      nullable: true,
    },
    isCompleted: {
      type: 'boolean',
      nullable: true,
    },
    paymentType: {
      type: 'string',
      nullable: true,
    },
    paymentTransactionId: {
      type: 'string',
      nullable: true,
    },
    paymentState: {
      type: 'string',
      nullable: true,
    },
    reminderState: {
      type: 'string',
      nullable: true,
    },
    integrationCallId: {
      type: 'integer',
      nullable: true,
    },
    requestObject: {
      type: 'string',
      nullable: true,
    },
    reminderSentOn: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    paymentObject: {
      type: 'string',
      nullable: true,
    },
    reminderIntegrationCallId: {
      type: 'integer',
      nullable: true,
    },
    language: {
      type: 'string',
      nullable: true,
    },
    comment: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
